module.exports = __webpack_public_path__ + "images/feature/file-dir-3-cc74d888bccd5349a53e8f86bd9e2008.png";